import React from "react";

import AuthContext, { IAuthContextType } from "./auth-context";

export const useAuth = (): IAuthContextType => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error("The hook useAuth must be used insider a AuthProvider");
  }
  return context;
};
